/**
 * Map trend CTA metadata to in-app routes (skipscreen-app paths).
 */
export function defaultTrendCtaLabel(ctaType: string): string {
  const map: Record<string, string> = {
    edit_prompt: 'Improve My Response',
    add_skills: 'Add Skills',
    update_profile: 'Update Profile',
    manage_portfolio: 'Update Portfolio',
    record_video: 'Record Intro Video',
  };
  return map[ctaType] ?? 'Take Action';
}

export function trendCtaHref(ctaType: string, ctaTarget: string): string {
  const enc = encodeURIComponent(ctaTarget);
  switch (ctaType) {
    case 'edit_prompt':
    case 'record_video':
      return `/prompts?cta=${enc}`;
    case 'add_skills':
      return '/user-profile';
    case 'update_profile':
      return '/user-profile';
    case 'manage_portfolio':
      return '/create-portfolio';
    default:
      return '/user-profile';
  }
}
